module.exports = __webpack_public_path__ + "media/images/ohap_new assignment_on-e5dfc5843b517d7c4420431cd4ad8235.png";